import { canv } from "@/canv/global";
import { drawRoundedRect, isOverRect } from "@/canv/utils";

export class CardWidgetStatusBarCheckBox {
    constructor(startX: number, startY: number, width: number, height: number) {
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.height = height;
    }

    updateCoords(startX: number, startY: number) {
        this.startX = startX;
        this.startY = startY;
    }

    setIsChecked(isChecked: boolean) {
        this.isChecked = isChecked;
    }

    draw() {
        const memGlobalAlpha = canv.ctx.globalAlpha;

        drawRoundedRect(this.startX, this.startY, this.width, this.height, 8);

        canv.ctx.lineWidth = 2;

        if (this.isChecked) {
            canv.ctx.strokeStyle = "#71BE38";
            canv.ctx.stroke();
        } else {
            canv.ctx.strokeStyle = "#D9D9D9";
            canv.ctx.stroke();

            if (
                this.fillOpacity == 0 &&
                isOverRect(this.startX, this.startY, this.width, this.height)
            ) {
                canv.ctx.fillStyle = "#FAFAFA";
                canv.ctx.fill();
            }
        }

        if (this.isChecked && this.fillOpacity < this.fillOpacityConst) {
            this.fillOpacity++;
            canv.redraw();
        }

        if (!this.isChecked && this.fillOpacity > 0) {
            this.fillOpacity--;
            canv.redraw();
        }

        canv.ctx.globalAlpha = this.fillOpacity / this.fillOpacityConst;
        canv.ctx.fillStyle = "#71BE38";
        canv.ctx.fill();

        this.drawCheck();

        canv.ctx.globalAlpha = memGlobalAlpha;
    }

    drawCheck() {
        canv.ctx.beginPath();

        const sdvigX = 0.0909 * this.width; // чтобы левый край касался границы box
        const sdvigY = 0.0909 * this.height; // чтобы верхний край касался границы box
        const checkWidth = 0.4545 * this.width;
        const checkHeight = 0.303 * this.height;
        const sdvigXToCenter = -sdvigX + this.width / 2 - checkWidth / 2;
        const sdvigYToCenter = -sdvigY + this.height / 2 - checkHeight / 2;

        canv.ctx.moveTo(
            this.startX + 0.0909 * this.width + sdvigXToCenter,
            this.startY + 0.2424 * this.height + sdvigYToCenter,
        );
        canv.ctx.lineTo(
            this.startX + 0.2424 * this.width + sdvigXToCenter,
            this.startY + 0.3939 * this.height + sdvigYToCenter,
        );
        canv.ctx.lineTo(
            this.startX + 0.5454 * this.width + sdvigXToCenter,
            this.startY + 0.0909 * this.height + sdvigYToCenter,
        );

        canv.ctx.lineCap = "round";
        canv.ctx.lineWidth = 3;
        canv.ctx.strokeStyle = "#FFFFFF";
        canv.ctx.stroke();
        canv.ctx.closePath();
    }

    startX = 0;
    startY = 0;
    width = 0;
    height = 0;

    isChecked = false;
    fillOpacity = 0;
    fillOpacityConst = 20;
}
